import React from 'react'
import {Field} from 'redux-form'

let ApplePayForm = props => {
  const { applepay } = props;

  return (
    <div>
      <h4>Apple Pay:</h4>

      <div className="form-group">
        <label htmlFor="merchantIdentifier">Merchant Identifier*</label>
        <Field className="form-control" name="applepay.merchantIdentifier" component="input" type="text"/>
      </div>

      <div className="form-group">
        <label htmlFor="displayName">Display name*</label>
        <Field className="form-control" name="applepay.displayName" component="input" type="text"/>
      </div>

      <div className="form-group">
        <label htmlFor="countryCode">Country code*</label>
        <Field className="form-control" name="applepay.countryCode" component="input" type="text"/>
      </div>

      <div className="form-group">
				<label htmlFor="domainName">
          Merchant validation URL <br />
          <small>(This field is only for testing purpose. It is not send to the widget! This field is used by the widget testing tool where we simulate merchant validation!)</small>
        </label>
				<Field className="form-control" name="applepay.validateMerchantUrl" component="input" type="text"/>
			</div>

      <div className="form-group">
        <div className="checkbox">
          <label>
            <Field component="input" name="applepay.applepayCallbacks" type="checkbox"/> <b>Use callbacks</b>
          </label>
        </div>
      </div>

      <div className="form-group">
        <div className="checkbox">
          <label>
            <Field component="input" name="applepay.useBillingAndShipping" type="checkbox"/> <b>Use billing and shipping addresses from Apple Pay</b>
          </label>
        </div>
      </div>

      <div>
        <h4>Risk settings:</h4>
        <div className="form-group">
          <div className="checkbox">
            <label>
              <Field name="deviceIdent" component="input" type="checkbox"/> <b>Device Ident</b>
            </label>
          </div>
        </div>
      </div>

      <div>
        <h4>Styles:</h4>
        <div className="form-group">
          <div className="checkbox">
            <label>
              <Field name="applepay.stylesUsage.general" component="input" type="checkbox"/> <b>Use styles:</b>
            </label>
          </div>
        </div>
      </div>

      {applepay.stylesUsage && applepay.stylesUsage.general && <div>

        <div className="row">
          <div className="col-sm-2">
            <div className="checkbox">
              <label>
                <Field name="applepay.stylesUsage.color" component="input" type="checkbox"/> <b>Type</b>
              </label>
            </div>
          </div>
          <div className="col-sm-10">
            {applepay.stylesUsage && applepay.stylesUsage.type && <div>
              <Field className="form-control" name="applepay.styles.type" component="input" type="text"/>
              <small>(plain, buy, donate, check-out, book or subscribe)</small>
            </div>}
          </div>
        </div>

        <div className="row">
          <div className="col-sm-2">
            <div className="checkbox">
              <label>
                <Field name="applepay.stylesUsage.color" component="input" type="checkbox"/> <b>Color</b>
              </label>
            </div>
          </div>
          <div className="col-sm-10">
            {applepay.stylesUsage && applepay.stylesUsage.color && <div>
              <Field className="form-control" name="applepay.styles.color" component="input" type="text"/>
              <small>(black, white or white-with-line)</small>
            </div>}
          </div>
        </div>

        <div className="row">
          <div className="col-sm-2">
            <div className="checkbox">
              <label>
                <Field name="applepay.stylesUsage.width" component="input" type="checkbox"/> <b>Width</b>
              </label>
            </div>
          </div>
          <div className="col-sm-10">
            {applepay.stylesUsage && applepay.stylesUsage.width && <div>
              <Field className="form-control" name="applepay.styles.width" component="input" type="text"/>
              <small>(Min width: 100px)</small>
            </div>}
          </div>
        </div>

        <div className="row">
          <div className="col-sm-2">
            <div className="checkbox">
              <label>
                <Field name="applepay.stylesUsage.height" component="input" type="checkbox"/> <b>Height</b>
              </label>
            </div>
          </div>
          <div className="col-sm-10">
            {applepay.stylesUsage && applepay.stylesUsage.height && <div>
              <Field className="form-control" name="applepay.styles.height" component="input" type="text"/>
              <small>(Min height: 32px, Max height: 64px)</small>
            </div>}
          </div>
        </div>

      </div>}
    </div>
  );
};

export default ApplePayForm;


// WEBPACK FOOTER //
// ./src/button/products/ApplePayForm.js